/**
 * @generated SignedSource<<2836fa3f2fdf6162031d760b5376a56b>>
 * @relayHash c7ace727849b1f0449d560cde95baa44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3086426ea67afdc98331e96a82222a65dcaf1d2fb8268c0ca8842edcdfa15782

import type { ConcreteRequest } from 'relay-runtime';
export type duplicate_duplicateAgentMutation$variables = {
  agentId: string;
};
export type duplicate_duplicateAgentMutation$data = {
  readonly agentStudio_duplicateAgent: {
    readonly agent: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type duplicate_duplicateAgentMutation = {
  response: duplicate_duplicateAgentMutation$data;
  variables: duplicate_duplicateAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "duplicate_duplicateAgentMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentStudioCreateAgentPayload",
        "kind": "LinkedField",
        "name": "agentStudio_duplicateAgent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicate_duplicateAgentMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentStudioCreateAgentPayload",
        "kind": "LinkedField",
        "name": "agentStudio_duplicateAgent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "3086426ea67afdc98331e96a82222a65dcaf1d2fb8268c0ca8842edcdfa15782",
    "metadata": {},
    "name": "duplicate_duplicateAgentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d8feac813ad718cc67fca8aac45e97fa";

export default node;
